import { sprintf } from './sprintf';

export function absUrl(path?: string) {
    if(path) {
        return sprintf('%s/#/%s', document.location.origin, path);
    } else {
        return document.location.href;
    }
}